import { Grid, Menu, MenuItem } from '@mui/material';
import { useCallback, useState } from 'react';
import GreenButton from '../../components/GreenButton';
import { useSystemModules } from '../systemModules/api/getSystemModules';

interface Props {
  handleMenuItemClicked: (selectedNode: string) => void;
}
const SystemOverviewMenu = ({ handleMenuItemClicked }: Props) => {
  const [newAnchorEl, setNewAnchorEl] = useState<null | HTMLElement>(null);
  const { data: modules } = useSystemModules({});
  const handleNewClicked = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setNewAnchorEl(event.currentTarget);
    },
    []
  );
  const handleMenuItemClickedAndCloseMenu = (
    selectedNode: string,
    e: React.MouseEvent<HTMLLIElement | MouseEvent>
  ) => {
    e.stopPropagation();
    handleMenuItemClicked(selectedNode);
    setNewAnchorEl(null);
  };
  return (
    <>
      <Grid item>
        <GreenButton name='New' onClick={handleNewClicked} />
      </Grid>
      <Menu
        id='new-menu'
        anchorEl={newAnchorEl}
        open={!!newAnchorEl}
        onClose={() => setNewAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          onClick={(e) => handleMenuItemClickedAndCloseMenu('satellite', e)}
        >
          Satellite
        </MenuItem>
        <MenuItem
          onClick={(e) => handleMenuItemClickedAndCloseMenu('location', e)}
        >
          Location
        </MenuItem>
        <MenuItem onClick={(e) => handleMenuItemClickedAndCloseMenu('dish', e)}>
          Dish
        </MenuItem>
        <MenuItem
          onClick={(e) => handleMenuItemClickedAndCloseMenu('analyzer', e)}
        >
          Analyzer
        </MenuItem>
        {modules?.SWITCHES && (
          <MenuItem
            onClick={(e) => handleMenuItemClickedAndCloseMenu('switch', e)}
          >
            Switch
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default SystemOverviewMenu;
